import { useState } from 'react';
import Icon from './Icon';

type Props = {
  name: string;
  component: JSX.Element;
  checked: boolean;
  setChecked: (value: boolean) => void;
};

type ReturnType = {
  checked: boolean;
  setChecked: (value: boolean) => void;
  CustomCheckbox: JSX.Element;
};

export default function Checkbox({ name, checked, setChecked, component }: Props): JSX.Element {
  return (
    <div className="flex items-start justify-center">
      <div className="reletive w-5 h-full flex flex-shrink-0 justify-center items-center">
        <input
          type="checkbox"
          name={name}
          className="absolute opacity-0"
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
        />
        <Icon name={checked ? 'checkbox_active' : 'checkbox_nor'} size="20" className="pointer-events-none"></Icon>
      </div>
      <div className="ml-2 flex items-start">{component}</div>
    </div>
  );
}

export function useCheckbox(options: Pick<Props, 'component' | 'name'>): ReturnType {
  const [checked, setChecked] = useState(false);

  return {
    checked,
    setChecked,
    CustomCheckbox: (
      <Checkbox
        {...{
          checked,
          setChecked,
          ...(options || {}),
        }}
      />
    ),
  };
}
